import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Linkedin, ExternalLink } from 'lucide-react';
export function Contacts() {
  return <div className="w-full bg-navy-900 min-h-screen flex items-center justify-center relative overflow-hidden py-24" data-id="element-161">
      <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-162"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(16,185,129,0.05)_0%,transparent_60%)]" data-id="element-163"></div>

      <div className="max-w-5xl mx-auto px-6 lg:px-12 relative z-10 w-full" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-white shadow-2xl overflow-hidden" data-id="element-165">
          <div className="grid md:grid-cols-5" data-id="element-166">
            {/* Left Branding Panel */}
            <div className="md:col-span-2 bg-gradient-to-br from-navy-900 to-navy-800 p-12 text-white flex flex-col justify-between relative overflow-hidden" data-id="element-167">
              <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-168"></div>
              <div className="relative z-10" data-id="element-169">
                <div className="w-16 h-16 bg-emerald-500 flex items-center justify-center text-navy-900 font-serif font-bold text-2xl mb-10 shadow-lg" data-id="element-170">
                  RGF
                </div>
                <h2 className="font-serif text-4xl mb-6 leading-tight" data-id="element-171">
                  Executive Contact Portal
                </h2>
                <div className="w-12 h-1 bg-emerald-500 mb-8" data-id="element-172"></div>
                <p className="text-slate-300 text-lg leading-relaxed" data-id="element-173">
                  Engage for Sovereign Board Placements, Institutional
                  Turnaround Advisory, or Public-Private Consortia Architecture.
                </p>
              </div>

              <div className="relative z-10 mt-16" data-id="element-174">
                <p className="text-sm text-slate-400 uppercase tracking-widest font-bold" data-id="element-175">
                  Direct Access
                </p>
              </div>
            </div>

            {/* Right Contact Info Panel */}
            <div className="md:col-span-3 p-12 md:p-16 bg-white flex flex-col justify-center" data-id="element-176">
              <div className="space-y-10" data-id="element-177">
                {/* LinkedIn */}
                <a href="https://www.linkedin.com/in/robert-frank-8239927/" target="_blank" rel="noopener noreferrer" className="flex items-start gap-6 group" data-id="element-178">
                  <div className="w-14 h-14 bg-slate-50 flex items-center justify-center rounded-sm group-hover:bg-emerald-500 group-hover:text-white transition-colors text-navy-900 shadow-sm border border-slate-100" data-id="element-179">
                    <Linkedin size={24} data-id="element-180" />
                  </div>
                  <div data-id="element-181">
                    <p className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-182">
                      Professional Network
                    </p>
                    <p className="text-xl text-navy-900 font-medium group-hover:text-emerald-600 transition-colors flex items-center gap-2" data-id="element-183">
                      LinkedIn Profile{' '}
                      <ExternalLink size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-184" />
                    </p>
                  </div>
                </a>

                {/* Email */}
                <div className="flex items-start gap-6 group" data-id="element-185">
                  <div className="w-14 h-14 bg-slate-50 flex items-center justify-center rounded-sm group-hover:bg-emerald-500 group-hover:text-white transition-colors text-navy-900 shadow-sm border border-slate-100" data-id="element-186">
                    <Mail size={24} data-id="element-187" />
                  </div>
                  <div data-id="element-188">
                    <p className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-189">
                      Direct Email
                    </p>
                    <div className="space-y-1" data-id="element-190">
                      <a href="mailto:rgfrank@unm.edu" className="block text-xl text-navy-900 font-medium hover:text-emerald-600 transition-colors" data-id="element-191">
                        rgfrank@unm.edu
                      </a>
                      <a href="mailto:rgfrank25@gmail.com" className="block text-xl text-navy-900 font-medium hover:text-emerald-600 transition-colors" data-id="element-192">
                        rgfrank25@gmail.com
                      </a>
                    </div>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start gap-6 group" data-id="element-193">
                  <div className="w-14 h-14 bg-slate-50 flex items-center justify-center rounded-sm group-hover:bg-emerald-500 group-hover:text-white transition-colors text-navy-900 shadow-sm border border-slate-100" data-id="element-194">
                    <Phone size={24} data-id="element-195" />
                  </div>
                  <div data-id="element-196">
                    <p className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-197">
                      Phone Contact
                    </p>
                    <a href="tel:+15056905260" className="text-xl text-navy-900 font-medium hover:text-emerald-600 transition-colors" data-id="element-198">
                      +1 (505) 690-5260
                    </a>
                  </div>
                </div>

                {/* Location */}
                <div className="flex items-start gap-6 group" data-id="element-199">
                  <div className="w-14 h-14 bg-slate-50 flex items-center justify-center rounded-sm group-hover:bg-emerald-500 group-hover:text-white transition-colors text-navy-900 shadow-sm border border-slate-100" data-id="element-200">
                    <MapPin size={24} data-id="element-201" />
                  </div>
                  <div data-id="element-202">
                    <p className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-203">
                      Primary Base
                    </p>
                    <p className="text-xl text-navy-900 font-medium" data-id="element-204">
                      Gainesville, Florida
                      <br data-id="element-205" />
                      <span className="text-lg text-slate-500" data-id="element-206">
                        United States
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}